import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full pb-4" }
const _hoisted_2 = { class: "text-xl text-center mt-2 mb-1" }
const _hoisted_3 = { class: "font-dmsans mb-3 text-lighterDark" }

import { useEventHandlers } from '@/composables/eventHandlers'
import { IonIcon } from '@ionic/vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'RefreshApp',
  props: {
    registration: {},
    slotProps: { default: undefined }
  },
  setup(__props: any) {

const props = __props;



const { clickDelay } = useEventHandlers()
const { t } = useI18n()
const refresh = async () => {
	if (props.registration.waiting) 
		props.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
	else
		window.location.reload()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonIcon), {
      src: require('@/assets/refresh.svg'),
      class: "gw-main-icon text-[3.125rem] rounded-md mx-auto text-primary"
    }, null, 8, ["src"]),
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)('content_updated')), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("content_updated_desc")), 1),
    _createElementVNode("button", {
      class: "gw-button -primary relative",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(clickDelay)(refresh)), ["prevent"]))
    }, [
      _createElementVNode("span", null, _toDisplayString(_unref(t)('refresh')), 1)
    ])
  ]))
}
}

})